import { MsaReceiptStatusType } from "./MsaReceiptStatusType";

export default class ReceiptVoidEvent {
    constructor(transactionId, tagId, gcid, voidReason, voidDateTime, voidedBy)
    {
        this.transactionId = transactionId.toString() || "";        
        this.tagId = tagId.toString() || "";
        this.gcid = gcid || "";
        this.status = MsaReceiptStatusType.VOIDED;
        this.voidReason = voidReason || "";
        this.voidDateTime = voidDateTime || "";
        this.voidedBy = voidedBy || "";
    }
}